const ArrowDown = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-5.46307e-08 1.2498C-4.06499e-08 0.92996 0.111608 0.60996 0.334825 0.36621C0.781259 -0.122071 1.50448 -0.122071 1.95091 0.36621L8.00009 6.98418L14.0491 0.366211C14.4955 -0.12207 15.2187 -0.12207 15.6652 0.366211C16.1116 0.854492 16.1116 1.64551 15.6652 2.13379L8.80795 9.63379C8.36152 10.1221 7.6383 10.1221 7.19187 9.63379L0.334646 2.13379C0.110715 1.89043 -6.8632e-08 1.57012 -5.46307e-08 1.2498Z"
        fill="#8C8C8C"
      />
    </svg>
  );
};

export default ArrowDown;
